import React from 'react';
import General from '../../ui/General/General';
import Card from '../../../../components/Card/Card';
import { ReactComponent as GeneralFilterIcon } from '../../../../../../resource/GeneralFilterIcon.svg';

const GeneralCard = () => {
  return (
    <Card
      heading="Общее"
      icon={<GeneralFilterIcon />}
    >
      <General />
    </Card>
  );
};

export default GeneralCard;
